module.exports = __webpack_public_path__ + "img/ql.d4fe1a21.png";